<template>
    <div>
        <v-autocomplete style="max-width: 400px;" multiple variant="outlined" item-title="plugin" :items="items"
            v-model="selectedItems" clearable chips closable-chips>
            <template v-slot:chip="{ props, item }">
                <v-chip v-bind="props" variant="flat" color="green" :text="item.plugin"></v-chip>
            </template>
            <template v-slot:item="{ props, item }">
                <v-list-item v-bind="props" :title="item.plugin"></v-list-item>
            </template>
        </v-autocomplete>
        <div class="position-relative">
            <v-btn color="success" :disabled="loading" @click="exportSettings()">Export</v-btn>
            <v-btn color="success" v-if="!loading && importString != '' && isJsonValid(importString)"
                @click="importSettings()" class="ml-2">Import</v-btn>
            <v-btn class="position-absolute top-0 right-0" color="success" v-if="exportSmart" :disabled="loading"
                @click="exportSmartMenu()">Export
                SmartMenu</v-btn>
        </div>

        <v-alert type="warning" v-if="!loading && importString != ''">Внимание, соотвествующие настройки будут
            перезаписаны;
            валидация
            строк не
            выполняется</v-alert>
        <v-textarea label="Укажите json-строку" v-model="importString"></v-textarea>
        <v-btn color="success" v-if="!loading && json != ''" @click="copy()" class="ml-2">Copy</v-btn>
        <div v-if="!loading" id="pluginSettingsText">
            {{ json }}
        </div>
        <v-skeleton-loader v-else type="article"></v-skeleton-loader>

    </div>
</template>

<script>

export default {

    data() {
        return {
            items: [],
            selectedItems: [],
            loading: false,
            json: '',
            importString: '',
            exportSmart: false
        }
    },
    created() {
        let module = this.$model.modules.service.modules.settingsImportExport;
        this.items = module.model.pluginList;
        this.exportSmart = module.model.exportSmartMenu
    },
    methods: {
        async copy() {
            navigator.clipboard.writeText(this.json)
        },
        exportSettings() {
            if (this.selectedItems.length) {
                this.loading = true;
                this.axios
                    .post(
                        this.$model.wwwroot + "/procollege/manage_groups/service/settingsImportExport/getPluginListSettings",
                        new URLSearchParams(
                            {
                                plugins: this.selectedItems.map((el) => "'" + el + "'").join(',')
                            }
                        )
                    )
                    .then((response) => {
                        this.json = JSON.stringify(response.data);
                    })
                    .catch((error) => {
                        this.axiosDefaultErrorHandler(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        exportSmartMenu() {
            this.loading = true;
            this.axios
                .post(
                    this.$model.wwwroot + "/procollege/manage_groups/service/settingsImportExport/smartMenuSettings",
                )
                .then((response) => {
                    this.json = JSON.stringify(response.data);
                })
                .catch((error) => {
                    this.axiosDefaultErrorHandler(error);
                })
                .finally(() => {
                    this.loading = false;
                });

        },
        importSettings() {
            this.loading = true;
            this.axios
                .post(
                    this.$model.wwwroot + "/procollege/manage_groups/service/settingsImportExport/import",
                    new URLSearchParams(
                        {
                            data: this.importString
                        }
                    )
                )
                .then((response) => {
                    this.importString = '';
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.axiosDefaultErrorHandler(error);
                });
        },
        isJsonValid(text) {
            try {
                JSON.parse(text);
                return true; // If parsing succeeds, it's valid JSON
            } catch (e) {
                console.log(e)
                return false; // If parsing fails (throws an error), it's invalid JSON
            }
        }
    }
};
</script>
